import React from 'react';
import styled from '@emotion/styled';
import ReactModal from 'react-modal';
import Recaptcha from 'react-recaptcha';
import ReactTooltip from 'react-tooltip';

import CopyEmailInput from '../CopyEmailInput';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    padding: '2rem',
  },
};

const StyledHeader = styled.h3`
  margin-bottom: 3px;
`;

const StyledParagraph = styled.p`
    font-size: 14px;
    margin-bottom: 12px;
`;

export default class ContactModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      verified: false,
      hasCopied: false,
    };

    this.verifyCallback = this.verifyCallback.bind(this);
    this.onCopy = this.onCopy.bind(this);
  }

  onCopy() {
    const el = document.createElement('textarea');
    el.value = 'alex@alexcatchpoledev.me';
    el.setAttribute('readonly', '');
    el.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    this.setState({ hasCopied: true });
    ReactTooltip.rebuild();
  }

  verifyCallback() {
    this.setState({ verified: true });
  }

  render() {
    const {
      toggle,
      isOpen,
    } = this.props;

    const { verified, hasCopied } = this.state;

    return (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={toggle}
        style={customStyles}
        overlayClassName="overlay"
        contentLabel="Example Modal"
      >
        <StyledHeader>Contact Me</StyledHeader>
        <StyledParagraph>You can view my email below:</StyledParagraph>
        {!verified && (
          <Recaptcha
            verifyCallback={this.verifyCallback}
            sitekey="6LchrqAUAAAAAHu-fdnsqAMVCk1_oppszNIi2Rfw"
          />
        )}
        {verified && <CopyEmailInput hasCopied={hasCopied} onCopy={this.onCopy} value="alex@alexcatchpoledev.me" />}
      </ReactModal>
    );
  }
};